import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Button, Grid, Form, Dropdown, Checkbox, Icon } from "semantic-ui-react";
import { server } from "../../App";
import { columnDefs, topOptions, bottomOptions } from "./GridParams/GridParams";
import { useNavigate, Link } from "react-router-dom";
import { useWindowSize } from "react-use";
import { emptyState_form_load, GetALLCLINICS } from "../Api/api";
import { useSelector, useDispatch } from "react-redux";
import { form_load } from "../../features/patientelle/patientelleSlice";
import { selectisAuthenticated, selectedIDAuth } from "../../features/auth/authSlice";
import {
  OnePriseEnChargeDATA,
  selectPriseEnChargeGrid,
  GlobalCheckBoxValideEnCoursBloc,
  PriseEnChargeDATAllRowsBloc,
  GlobalDATEBloc1,

  GlobalSelectClinique,
  GlobalSelectmutualiste,
  GlobalSelectOpere
} from "../../features/PriseEnCharge/PriseEnChargeSlice";

import {
  mutualisteOptions,
  opereOptions
} from "../Consultation/bloc3/DropdownOptions/AvOptions";
import { Provider, defaultTheme } from "@adobe/react-spectrum";
import { DateRangePicker } from "@react-spectrum/datepicker";
import { parseDate } from '@internationalized/date';
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"
import { useQuery } from "react-query";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"

function Bloc_Main(props) {

  const data = useGetDoctorsSemanticUI()
  // const { date } = props;
  let navigate = useNavigate();

  const PriseEnChargeState = useSelector(selectPriseEnChargeGrid);
  const Auth = useSelector(selectisAuthenticated);

  // APP state
  const dispatch = useDispatch();

  const [, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [hideColumn, setHideColumn] = useState(true);
  const [stat, setStat] = useState([]);
  const [showBtn, setshowBtn] = useState(false);
  const { width, height } = useWindowSize();
  const [NewHeightValue, setNewHeightValue] = useState("87vh");

  // const [Year, setYear] = useState(moment().format("YYYY"));
  // const [Month, setMonth] = useState(moment().format("MM"));

  const {

    GlobalCheckBoxValEnCoBloc,
    priseEnChargeDataAllRowsBloc,
    date,
    priseEnChargeClinique,
    mutualiste,
    opere
  } = PriseEnChargeState;

  const {
    selectID
  } = Auth

  const Type_clinic = useQuery("GetALLCLINICS", () =>
    GetALLCLINICS()
  );
  let allclinics = Type_clinic?.data?.map((item, index) => (
    { key: item.idclinique, text: item.NomClinique, value: item.idclinique }
  ))

  let myObject = { key: "0000000A", text: "Global", value: "all" }

  allclinics = allclinics ? allclinics : []

  allclinics.push(myObject)

  const GetAllBlocdata = async () => {
    // console.log("data", data);
    let url, url2;
    if (selectID) {
      if (GlobalCheckBoxValEnCoBloc === 0) {
        url = `${server}Bloc/GetBlocBetweenTwoDates/${date.start}/${date.end}/0/${selectID}/${priseEnChargeClinique}/${mutualiste}/${opere}`;
        url2 = `${server}Bloc/GetBlocBetweenTwoDatesStatistique/${date.start}/${date.end}/0/${selectID}/${priseEnChargeClinique}/${mutualiste}/${opere}`;
      } else {
        url = `${server}Bloc/GetBlocBetweenTwoDates/${date.start}/${date.end}/1/${selectID}/${priseEnChargeClinique}/${mutualiste}/${opere}`;
        url2 = `${server}Bloc/GetBlocBetweenTwoDatesStatistique/${date.start}/${date.end}/1/${selectID}/${priseEnChargeClinique}/${mutualiste}/${opere}`;
      }
    }
    axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(PriseEnChargeDATAllRowsBloc(response.data));
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(url2, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        setStat(response.data)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetAllBlocdata();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    GetAllBlocdata();
  },
    [
      GlobalCheckBoxValEnCoBloc,
      selectID,
      date,
      priseEnChargeClinique,
      mutualiste,
      opere
    ]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    // params.api.sizeColumnsToFit();
    // gridApi?.resetRowHeights();
  };

  topOptions.alignedGrids.push(bottomOptions);
  // bottomOptions.alignedGrids.push(topOptions);

  const showColumn = () => {
    gridColumnApi.setColumnsVisible(
      ["Nom_Type_D_Operationcol", "comentaire", "user_name", "mutualiste", "done", "NomClinique"],
      hideColumn
    );

    setHideColumn(!hideColumn);
    // to fit the size of column FIX COLUMN BUG
    // gridApi.sizeColumnsToFit();
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(OnePriseEnChargeDATA({}));
      setshowBtn(false)
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      dispatch(OnePriseEnChargeDATA(clientArray));
      setshowBtn(true)
      // console.log(clientArray)
    }
  };

  const onRowDoubleClicked = (e) => {
    e.defaultPrevented = true;
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(form_load(emptyState_form_load));
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      axios
        .get(
          `${server}users/SearchUserByID/${clientArray.fk_id_patient}`,
          {
            headers: {
              jwtoken: sessionStorage.token,
            },
          }
        )
        .then((response) => {
          sessionStorage.setItem(
            "ID_Block",
            clientArray.fk_id_patient
          );
          dispatch(form_load(response.data[0]));
          navigate("/Consultation");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  function name(height, width) {
    if (height <= 702 && height >= 600 && width >= 1260 && width <= 1366) {
      setNewHeightValue("82vh");
    } else {
      setNewHeightValue("87.5vh");
    }
  }
  useEffect(() => {
    name(height, width);
  }, [height, width]);

  let summary = (
    <>
      <span style={{ fontWeight: 900, fontStyle: "italic" }}>
        Total Fact. :{" "}
        <span
          style={{ fontWeight: 900, color: "royalblue", fontStyle: "italic" }}
        >
          {" "}
          {stat[0]?.totalMontant
            ? `${new Intl.NumberFormat('de-DE').format(stat[0]?.totalMontant)} DH`
            : "0 DH"}
        </span>
      </span>
      <span
        style={{
          paddingLeft: "0.6rem",
          fontWeight: 900,
          fontStyle: "italic",
        }}
      >
        Encaiss. :{" "}
        <span
          style={{
            fontWeight: 900,
            color: "#04aa6d",
            fontStyle: "italic",
          }}
        >
          {" "}
          {stat[0]?.TotalPayments
            ? `${new Intl.NumberFormat('de-DE').format(stat[0]?.TotalPayments)} DH`
            : "0 DH"}
        </span>
      </span>
      <span
        style={{
          paddingLeft: "0.6rem",
          fontWeight: 900,
          fontStyle: "italic",
        }}
      >
        Reste :{" "}
        <span
          style={{
            fontWeight: 900,
            color: "orangered",
            fontStyle: "italic",
          }}
        >
          {" "}
          {stat[0]?.reste
            ? `${new Intl.NumberFormat('de-DE').format(stat[0]?.reste)} DH`
            : "0 DH"}
        </span>
      </span>
    </>
  );


  return (
    <>
      <Grid columns="equal" centered className="fixWidth3">

        {/* <Grid.Column> */}

        <Form.Field
        // className="checkboxBloc"
        >
          <Checkbox
            toggle
            label={` Validé`}
            name="checkboxRadioGroup"
            value={1}
            checked={GlobalCheckBoxValEnCoBloc === 1}
            onChange={(e, data) =>
              dispatch(GlobalCheckBoxValideEnCoursBloc(data.value))
            }
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            toggle
            label="En cours"
            name="checkboxRadioGroup"
            value={0}
            checked={GlobalCheckBoxValEnCoBloc === 0}
            onChange={(e, data) =>
              dispatch(GlobalCheckBoxValideEnCoursBloc(data.value))
            }
          />
        </Form.Field>

        {/* </Grid.Column> */}

        {/* </Grid.Column> */}

        {/* <Grid.Column> */}
        <Grid.Row className="emptyPadding">
          <Form.Field
            className="SomeMargin"
            value={selectID}
            search
            selection
            fluid
            label="Médecin"
            control={Dropdown}
            options={data?.Doctors_list ? data?.Doctors_list : []}
            placeholder="Select Doctor"
            onChange={(e, data) => {
              dispatch(selectedIDAuth(data.value));
            }}
          />
          <Form.Field
            // className="TinySelect"
            value={priseEnChargeClinique}
            search
            selection
            fluid
            label="Clinique"
            control={Dropdown}
            options={allclinics ? allclinics : []}
            placeholder="Select clinic"
            onChange={(e, data) => {
              dispatch(GlobalSelectClinique(data.value));
            }}
          />

        </Grid.Row>
        <Grid.Row className="emptyPadding">

          <Provider theme={defaultTheme} colorScheme="light" locale="fr-FR" height="100%">
            <DateRangePicker width={width < 380 ? "size-3000" : "size-3010"} backgroundColor="gray-50" aria-label="intervalle de date" value={{ start: parseDate(date.start), end: parseDate(date.end) }} onChange={(range) => dispatch(GlobalDATEBloc1({ start: (range?.start.toString()), end: (range?.end.toString()) }))} />
          </Provider>
        </Grid.Row>
        <Grid.Row className="emptyPadding">
          {/* <label
            style={{
              lineHeight: "2.9em",
              paddingRight: "0.7rem",
              paddingLeft: "0.7rem",
              fontWeight: "bold",
            }}
          >
            Mutuelle :
          </label> */}
          <Form.Field
            className="SomeMargin"
            value={mutualiste}
            search
            selection
            fluid
            label="Mutuelle :"
            control={Dropdown}
            options={mutualisteOptions}
            placeholder="Mutualiste"
            onChange={(e, data) => {
              dispatch(GlobalSelectmutualiste(data.value));
            }}
          />
          {/* <label
            style={{
              lineHeight: "2.9em",
              paddingRight: "0.7rem",
              paddingLeft: "0.7rem",
              fontWeight: "bold",
            }}
          >
            Opéré :
          </label> */}
          <Form.Field
            className="SomeMargin"
            value={opere}
            search
            selection
            fluid
            label="Opéré :"
            control={Dropdown}
            options={opereOptions}
            placeholder="Mutualiste"
            onChange={(e, data) => {
              dispatch(GlobalSelectOpere(data.value));
            }}
          />
        </Grid.Row>
        <Grid.Row className="emptyPadding">
          {summary}
        </Grid.Row>


        {/* </Grid.Column> */}
        <Grid.Row className="emptyPadding">
          {/* <Button.Group vertical={width <= 767 ? true : false}> */}
          <Link to="/PatientelleGridBloc">
            <Button className="someMarginBottom" color="green"
              style={{
                // paddingLeft: "0.8rem",
                paddingRight: "0.8rem"
              }}
            ><Icon name='add' size='large' />Ajouter</Button>
          </Link>
          {showBtn ?
            <Link to="/UpdateBloc">
              <Button color="orange"
                style={{
                  // paddingLeft: "0.8rem",
                  paddingRight: "0.8rem"
                }}
              ><Icon name='edit' size='large' />Modifier</Button>
            </Link>
            :
            <Link to="/bloc_Main">
              <Button color="orange"
                style={{
                  // paddingLeft: "0.8rem",
                  paddingRight: "0.8rem"
                }}
              ><Icon name='edit' size='large' />Modifier</Button>
            </Link>}
          {priseEnChargeDataAllRowsBloc?.length > 0 ?
            <Link to="/PapierBloc">
              <Button color="teal"
                style={{
                  // paddingLeft: "0.8rem",
                  paddingRight: "0.8rem"
                }}
              ><Icon size='large' name='print' />Programme bloc </Button>
            </Link>
            :
            <Link to="/bloc_Main">
              <Button color="teal"
                style={{
                  // paddingLeft: "0.8rem",
                  paddingRight: "0.8rem"
                }}
              ><Icon size='large' name='print' />Programme bloc  </Button>
            </Link>}

          {showBtn ?
            <Link to="/DeleteOneBloc">
              <Button
                style={{
                  // paddingLeft: "0.8rem",
                  paddingRight: "0.8rem"
                }}
                color="red">  <Icon name='delete' size='large' />Supprimer</Button>
            </Link> :

            <Link to="/bloc_Main">
              <Button
                style={{
                  // paddingLeft: "0.8rem",
                  paddingRight: "0.8rem"
                }}
                color="red">  <Icon name='delete' size='large' />Supprimer</Button>
            </Link>

          }


          {/* {PatientelleState.nom === undefined ? (
              <Link to="/PriseEnCharge">
                <Button className="IconFixDopdown" color="blue">
                  CreatePriseEnChagre
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/PriseEnCharge">
                <Button className="IconFixDopdown" color="blue">
                  CreatePriseEnChagre
                </Button>
              </Link>
            ) : (
              <Link to="/CreatePriseEnChagre">
                <Button className="IconFixDopdown" color="blue">
                  CreatePriseEnChagre
                </Button>
              </Link>
            )} */}
          {/* <Button onClick={showColumn} className="littleMarginBottom">
            {hideColumn === true
              ? "Basculer vers l'Affichage Avancé"
              : "Basculer vers l'Afffichage Basic"}
          </Button>
          <Link to="/">
            <Button floated="right" color="blue">
              Retour
            </Button>
          </Link> */}
          {/* </Button.Group> */}
        </Grid.Row>
      </Grid>
      <div
        id="myGrid"
        className="ag-theme-alpine"
        style={{
          height: NewHeightValue,
          width: "100%",
          flex: "1 1 auto",
        }}
      >
        <AgGridReact
          rowData={priseEnChargeDataAllRowsBloc}
          animateRows={true}
          sortingOrder={["desc", "asc", null]}
          onGridReady={onGridReady}
          columnDefs={columnDefs}
          // defaultColDef={defaultColDef}
          rowSelection={"single"}
          onSelectionChanged={onSelectionChanged}
          gridOptions={topOptions}
          onRowDoubleClicked={onRowDoubleClicked}
        // onFirstDataRendered={onFirstDataRendered}
        ></AgGridReact>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <SpeedDialComponent showColumn={showColumn} hideColumn={hideColumn} />
    </>
  );
}

export default Bloc_Main;
